import {
	FormControlLabel,
	FormGroup,
	Grid,
	Input,
	InputBase,
	makeStyles,
	Switch,
	Tab,
	Tabs,
	TextField,
	withStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import './Finances.css';
import dayjs from 'dayjs';
import Modal from '../../layout/modal/Modal';
import DatePicker from 'react-datepicker';
import clsx from 'clsx';
import Calendar from 'react-calendar';

function Finances({
	irrevocableDate,
	mortgageDetails,
	setMortgageDetails,
	setIsCompleted,
	isCompleted,
	elevationList,
	elevationPrice,
	lotPrice,
	upgradeTotalPrice,
	setDisable,
	disable,
	setDisplayFinal,
	displayFinal,
	firstInstallmentDate,
	setFirstInstallmentDate,
	firstInstallmentCost,
	setFirstInstallmentCost,
	secondInstallmentDate,
	setSecondInstallmentDate,
	secondInstallmentCost,
	setSecondInstallmentCost,
	thirdInstallmentDate,
	setThirdInstallmentDate,
	thirdInstallmentCost,
	setThirdInstallmentCost,
	forthInstallmentDate,
	setForthInstallmentDate,
	forthInstallmentCost,
	setForthInstallmentCost,
	fifthInstallmentDate,
	setFifthInstallmentDate,
	fifthInstallmentCost,
	setFifthInstallmentCost,
	sixthInstallmentDate,
	setSixthInstallmentDate,
	sixthInstallmentCost,
	setSixthInstallmentCost,
	finalCost,
	totalMainFloor,
}) {
	const [value, setValue] = useState(1);
	const [showCalendar, setShowCalendar] = useState(false);

	// Modal
	const [firstInstallmentDateModal, setFirstInstallmentDateModal] = useState(
		new Date()
	);
	const [firstInstallmentCostModal, setFirstInstallmentCostModal] =
		useState(firstInstallmentCost);

	const [secondInstallmentDateModal, setSecondInstallmentDateModal] =
		useState(dayjs(new Date()).unix() * 1000 + 86400000 * 45);
	const [secondInstallmentCostModal, setSecondInstallmentCostModal] =
		useState(secondInstallmentCost);

	const [thirdInstallmentDateModal, setThirdInstallmentDateModal] = useState(
		dayjs(new Date()).unix() * 1000 + 86400000 * 90
	);
	const [thirdInstallmentCostModal, setThirdInstallmentCostModal] =
		useState(thirdInstallmentCost);
	const [forthInstallmentDateModal, setForthInstallmentDateModal] = useState(
		dayjs(new Date()).unix() * 1000 + 86400000 * 120
	);
	const [forthInstallmentCostModal, setForthInstallmentCostModal] =
		useState(forthInstallmentCost);
	const [fifthInstallmentDateModal, setFifthInstallmentDateModal] = useState(
		dayjs(new Date()).unix() * 1000 + 86400000 * 180
	);
	const [fifthInstallmentCostModal, setFifthInstallmentCostModal] =
		useState(fifthInstallmentCost);
	const [sixthInstallmentDateModal, setSixthInstallmentDateModal] = useState(
		dayjs(new Date()).unix() * 1000 + 86400000 * 365
	);
	const [sixthInstallmentCostModal, setSixthInstallmentCostModal] =
		useState(sixthInstallmentCost);

	const [approvalDate, setApprovalDate] = useState(new Date().getTime());

	useEffect(() => {
		var cost =
			Number(totalMainFloor) + Number(lotPrice) + Number(elevationPrice);
		setSecondInstallmentCost(cost * 0.025 - 30000);
		setThirdInstallmentCost(cost * 0.025);
		setForthInstallmentCost(cost * 0.05);
		setFifthInstallmentCost(cost * 0.05);
		setSixthInstallmentCost(0);
	}, []);

	const handleSaveInstallment = () => {
		setShow(false);

		setFirstInstallmentDate(
			dayjs(firstInstallmentDateModal).format('DD MMM YYYY')
		);
		setFirstInstallmentCost(firstInstallmentCostModal);

		setSecondInstallmentDate(
			dayjs(secondInstallmentDateModal).format('DD MMM YYYY')
		);
		setSecondInstallmentCost(secondInstallmentCostModal);

		setThirdInstallmentDate(
			dayjs(thirdInstallmentDateModal).format('DD MMM YYYY')
		);
		setThirdInstallmentCost(thirdInstallmentCostModal);

		setForthInstallmentDate(
			dayjs(forthInstallmentDateModal).format('DD MMM YYYY')
		);
		setForthInstallmentCost(forthInstallmentCostModal);

		setFifthInstallmentDate(
			dayjs(fifthInstallmentDateModal).format('DD MMM YYYY')
		);
		setFifthInstallmentCost(fifthInstallmentCostModal);

		setSixthInstallmentDate(
			dayjs(sixthInstallmentDateModal).format('DD MMM YYYY')
		);
		setSixthInstallmentCost(sixthInstallmentCostModal);
	};

	const [show, setShow] = useState(false);

	const [formData, setFormData] = useState({
		lendingInstitution: mortgageDetails?.institutionName
			? mortgageDetails?.institutionName
			: '',
		agentName: mortgageDetails?.agentName ? mortgageDetails?.agentName : '',
		mortgageValue: mortgageDetails?.totalDownpayment
			? mortgageDetails?.totalDownpayment
			: '',
	});

	const { lendingInstitution, agentName, mortgageValue } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const onChangeModal = (e) => {
		if (e.target.name === 'firstInstallmentCostModal') {
			setFirstInstallmentCostModal(e.target.value);
		} else if (e.target.name === 'secondInstallmentCostModal') {
			setSecondInstallmentCostModal(e.target.value);
		} else if (e.target.name === 'thirdInstallmentCostModal') {
			setThirdInstallmentCostModal(e.target.value);
		} else if (e.target.name === 'forthInstallmentCostModal') {
			setForthInstallmentCostModal(e.target.value);
		} else if (e.target.name === 'fifthInstallmentCostModal') {
			setFifthInstallmentCostModal(e.target.value);
		} else if (e.target.name === 'sixthInstallmentCostModal') {
			setSixthInstallmentCostModal(e.target.value);
		}
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			marginTop: '10px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
			width: '100%',
		},
		datePicker: {
			marginTop: '10px',
			width: '100%',
			height: '54px',
			border: '1px solid #bdbaba',
		},
		label: {
			marginBottom: '-2.3em',
			fontSize: '10px',
			color: 'grey',
		},
		installmentDate: {
			// width: '25em',
		},
		financeTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '22em',
			borderRadius: '8px',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => (
		<Tabs {...props} TabIndicatorProps={{ children: <span /> }} />
	));

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',
			borderRadius: '8px',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	const handleChange = (event, newValue) => {
		if (newValue === 1) {
			setMortgageDetails();
			setDisable({ ...disable, finances: false });
		} else if (newValue === 0) {
			setIsCompleted({ ...isCompleted, finances: false });

			setDisable({ ...disable, finances: true });
		}
		setValue(newValue);
	};

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	useEffect(() => {
		if (value === 1) {
			setIsCompleted({ ...isCompleted, finances: true });
			setDisplayFinal({ ...displayFinal, finances: true });
			setDisable({ ...disable, finances: false });
			setMortgageDetails();
		}
	}, [value]);

	const handleSave = () => {
		setIsCompleted({ ...isCompleted, finances: true });
		setDisable({ ...disable, finances: false });
		setMortgageDetails({
			institutionName: lendingInstitution,
			agentName: agentName,
			totalDownpayment: mortgageValue,
		});
	};

	const closeModalHandler = () => setShow(false);

	return (
		<div className='doc_card finances_wrapper'>
			<div className='card_title'>
				Is the client pre-approved for a mortgage?
			</div>
			<div className={styles.financeTab}>
				<div className={styles.clientTab}>
					<StyledTabs value={value} onChange={handleChange} centered>
						<StyledTab label={'Yes'} />
						<StyledTab label={'No'} />
					</StyledTabs>
				</div>
			</div>
			<div className={styles.root}>
				{value === 0 ? (
					<div className='mortgage_form'>
						<TextField
							type='text'
							label='Lending Institution'
							name='lendingInstitution'
							value={lendingInstitution}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						<TextField
							type='text'
							label='Name of mortgage agent'
							name='agentName'
							value={agentName}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						<TextField
							type='number'
							label='Mortgage Value'
							name='mortgageValue'
							value={mortgageValue}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>

						<TextField
							type='text'
							label='Approval Date'
							name='approvalDate'
							value={dayjs(approvalDate).format('DD MMMM YYYY')}
							className={styles.field}
							onChange={(e) => onChange(e)}
							onClick={() => setShowCalendar(true)}
						/>

						{showCalendar === true && (
							<div className='dates_wrapper'>
								<Calendar
									onChange={(e) => {
										setApprovalDate(new Date(e).getTime());
										setShowCalendar(false);
									}}
									value={new Date(approvalDate)}
									className='new-react-calendar'
									minDate={new Date()}
									showFixedNumberOfWeeks={true}
								/>
							</div>
						)}
						<button
							className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
							onClick={() => handleSave()}
						>
							Save
						</button>
					</div>
				) : null}

				<div className='card_title'>Downpayment schedule</div>
				<div className='downpayments_group'>
					<div className='downpayment_item'>
						<div className='schedule_title'>First Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{firstInstallmentDate &&
								dayjs(firstInstallmentDate).format(
									'DD MMM YYYY'
								)}

							<span className='installment_price'>
								$
								{console.log(
									'firstInstallmentCostfirstInstallmentCost',
									firstInstallmentCost
								)}
								{firstInstallmentCost
									? numberWithCommas(firstInstallmentCost)
									: 0}
							</span>
						</small>
						<br />
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Second Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{dayjs(secondInstallmentDate).format('DD MMM YYYY')}
							<span className='installment_price'>
								$
								{console.log(
									'secondInstallmentCostsecondInstallmentCost',
									secondInstallmentCost
								)}
								{secondInstallmentCost
									? numberWithCommas(secondInstallmentCost)
									: 0}
							</span>
						</small>
						<br />
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Third Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{dayjs(thirdInstallmentDate).format('DD MMM YYYY')}
							<span className='installment_price'>
								$
								{thirdInstallmentCost
									? numberWithCommas(thirdInstallmentCost)
									: 0}
							</span>
							{console.log(thirdInstallmentDate)}
						</small>
						<br />
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Forth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{dayjs(forthInstallmentDate).format('DD MMM YYYY')}
							<span className='installment_price'>
								$
								{forthInstallmentCost
									? numberWithCommas(forthInstallmentCost)
									: 0}
							</span>
						</small>
						<br />
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Fifth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{dayjs(fifthInstallmentDate).format('DD MMM YYYY')}
							<span className='installment_price'>
								{console.log(
									'fifthInstallmentCost',
									fifthInstallmentCost
								)}
								$
								{fifthInstallmentCost
									? numberWithCommas(fifthInstallmentCost)
									: 0}
							</span>
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Sixth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{dayjs(sixthInstallmentDate).format('DD MMM YYYY')}
							<span className='installment_price'>
								$
								{sixthInstallmentCost
									? numberWithCommas(sixthInstallmentCost)
									: 0}
							</span>
						</small>
						<br />
					</div>
				</div>

				{show ? (
					<div
						onClick={closeModalHandler}
						className='back-drop'
					></div>
				) : null}
				<Modal
					show={show}
					close={closeModalHandler}
					title='Edit Installments'
					buttonName='Save'
					button={handleSaveInstallment}
				>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={firstInstallmentDateModal}
								id='date'
								placeholderText='First Installment Date'
								minDate={Date.now()}
								onChange={(date) =>
									setFirstInstallmentDateModal(date)
								}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={firstInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='First Installment Cost'
								name='firstInstallmentCostModal'
								value={firstInstallmentCostModal}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
							/>
						</Grid>
					</Grid>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={secondInstallmentDateModal}
								id='date'
								placeholderText='Second Installment Date'
								minDate={Date.now()}
								onChange={(date) =>
									setSecondInstallmentDateModal(date)
								}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={secondInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='Second Installment Cost'
								name='secondInstallmentCostModal'
								value={secondInstallmentCostModal}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
							/>
						</Grid>
					</Grid>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={thirdInstallmentDateModal}
								id='date'
								placeholderText='Third Installment Date'
								minDate={Date.now()}
								onChange={(date) =>
									setThirdInstallmentDateModal(date)
								}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={thirdInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='Third Installment Cost'
								name='thirdInstallmentCostModal'
								value={thirdInstallmentCostModal}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
							/>
						</Grid>
					</Grid>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={forthInstallmentDateModal}
								id='date'
								placeholderText='Forth Installment Date'
								minDate={Date.now()}
								onChange={(date) =>
									setForthInstallmentDateModal(date)
								}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={forthInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='Forth Installment Cost'
								name='forthInstallmentCostModal'
								value={forthInstallmentCostModal}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
							/>
						</Grid>
					</Grid>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={fifthInstallmentDateModal}
								id='date'
								placeholderText='Fifth Installment Date'
								minDate={Date.now()}
								onChange={(date) =>
									setFifthInstallmentDateModal(date)
								}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={fifthInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='Fifth Installment Cost'
								name='fifthInstallmentCostModal'
								value={fifthInstallmentCostModal}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
							/>
						</Grid>
					</Grid>
					<Grid container alignItems='flex-start' spacing={1}>
						<Grid item xs={6}>
							<DatePicker
								selected={new Date(sixthInstallmentDate)}
								id='date'
								placeholderText='Sixth Installment Date'
								minDate={Date.now()}
								onChange={(date) => {
									console.log('dsdsfsfa', date);
									setSixthInstallmentDateModal(date);
								}}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
								autoComplete='off'
								value={sixthInstallmentDateModal}
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								type='number'
								label='Sixth Installment Cost'
								name='sixthInstallmentCostModal'
								value={sixthInstallmentCost}
								className={styles.field}
								onChange={(e) => onChangeModal(e)}
								variant='outlined'
								value={sixthInstallmentCostModal}
							/>
						</Grid>
					</Grid>
				</Modal>
			</div>
		</div>
	);
}

export default Finances;
